import { clearAllStaffOptionCaches } from '@/config/search-configs';
import { useStaffStore } from '@/features/companies/stores';

export const clearAllStaffCaches = (): void => {
  clearAllStaffOptionCaches();

  const { clearStaffs, clearStaffsByDepartment } = useStaffStore.getState();
  clearStaffs();
  clearStaffsByDepartment();
};
